import { Component, OnInit } from '@angular/core';
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-doctordashbord',
  templateUrl: './doctordashbord.component.html',
  styleUrls: ['./doctordashbord.component.css']
})
export class DoctordashbordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
